/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ellipsis_CharInputs */



/**
* | output |
* | --- |
* | "( … ) Ellipsis" |
*
* @param {Ellipsis_CharInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ellipsis_char = /** @type {((inputs?: Ellipsis_CharInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ellipsis_CharInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("( … ) Points de suspension")
	if (locale === "de") return /** @type {LocalizedString} */ ("( … ) Auslassungspunkte")
	if (locale === "it") return /** @type {LocalizedString} */ ("( … ) Ellissi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("( … ) Многоточие")
	if (locale === "es") return /** @type {LocalizedString} */ ("( … ) Elipsis")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("（…）省略号")
	if (locale === "ja") return /** @type {LocalizedString} */ ("（…）省略記号")
	if (locale === "hi") return /** @type {LocalizedString} */ ("( … ) दीर्घवृत्त")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("(...) Elipse")
	return /** @type {LocalizedString} */ ("( … ) Ellipsis")
});